 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import BUNDLE_COVER from '@/components/bundle_cover'
 import BOOK1BACKEDEBB from '@/components/Book1/Backed/ebb'
 import BOOK1BACKEDTLU from '@/components/Book1/Backed/tlu'
 import BOOK1BACKEDMM from '@/components/Book1/Backed/mm'
 import LOVE_1 from '@/components/love_1'
 import BUNDLE_TITLE from '@/components/bundle_title'
 import BUNDLE_CONTENT from '@/components/bundle_content'
 import BOOK11COVER from '@/components/Book1/1-cover'
 import BOOK12TITLE_PAGE from '@/components/Book1/2-title_page'
 import BOOK13DEDICATION from '@/components/Book1/3-dedication'
 import BOOK14TOC from '@/components/Book1/4-TOC'
 import BOOK15START from '@/components/Book1/5-start'
 import BOOK16CHAP2 from '@/components/Book1/6-chap2'
 import BOOK17CHAP3 from '@/components/Book1/7-chap3'
 import BOOK18CHAP4 from '@/components/Book1/8-chap4'
 import BOOK19CHAP5 from '@/components/Book1/9-chap5'
 import BOOK110CHAP6 from '@/components/Book1/10-chap6'
 import BOOK111CHAP7 from '@/components/Book1/11-chap7'
 import BOOK112CHAP8 from '@/components/Book1/12-chap8'
 import BOOK113CHAP9 from '@/components/Book1/13-chap9'
 import BOOK114CHAP10 from '@/components/Book1/14-chap10'
 import BOOK115CHAP11 from '@/components/Book1/15-chap11'
 import BOOK116CHAP12 from '@/components/Book1/16-chap12'
 import BOOK117CHAP13 from '@/components/Book1/17-chap13'
 import BOOK118CHAP14 from '@/components/Book1/18-chap14'
 import BOOK119CHAP15 from '@/components/Book1/19-chap15'
 import BOOK120CHAP16 from '@/components/Book1/20-chap16'
 import BOOK121CHAP17 from '@/components/Book1/21-chap17'
 import BOOK122CHAP18 from '@/components/Book1/22-chap18'
 import BOOK123CHAP19 from '@/components/Book1/23-chap19'
 import BOOK124CHAP20 from '@/components/Book1/24-chap20'
 import BOOK125CHAP21 from '@/components/Book1/25-chap21'
 import BOOK126CHAP22 from '@/components/Book1/26-chap22'
 import BOOK21COVER from '@/components/Book2/1-cover'
 import BOOK22TITLE_PAGE from '@/components/Book2/2-title_page'
 import BOOK23DEDICATION from '@/components/Book2/3-dedication'
 import BOOK24TOC from '@/components/Book2/4-TOC'
 import BOOK25START from '@/components/Book2/5-start'
 import BOOK26CHAP2 from '@/components/Book2/6-chap2'
 import BOOK27CHAP3 from '@/components/Book2/7-chap3'
 import BOOK28CHAP4 from '@/components/Book2/8-chap4'
 import BOOK29CHAP5 from '@/components/Book2/9-chap5'
 import BOOK210CHAP6 from '@/components/Book2/10-chap6'
 import BOOK211CHAP7 from '@/components/Book2/11-chap7'
 import BOOK212CHAP8 from '@/components/Book2/12-chap8'
 import BOOK213CHAP9 from '@/components/Book2/13-chap9'
 import BOOK214CHAP10 from '@/components/Book2/14-chap10'
 import BOOK215CHAP11 from '@/components/Book2/15-chap11'
 import BOOK216CHAP12 from '@/components/Book2/16-chap12'
 import BOOK217CHAP13 from '@/components/Book2/17-chap13'
 import BOOK218CHAP14 from '@/components/Book2/18-chap14'
 import BOOK219CHAP15 from '@/components/Book2/19-chap15'
 import BOOK220CHAP16 from '@/components/Book2/20-chap16'
 import BOOK221CHAP17 from '@/components/Book2/21-chap17'
 import BOOK222CHAP18 from '@/components/Book2/22-chap18'
 import BOOK223CHAP19 from '@/components/Book2/23-chap19'
 import BOOK224CHAP20 from '@/components/Book2/24-chap20'
 import BOOK225CHAP21 from '@/components/Book2/25-chap21'
 import BOOK226ACK from '@/components/Book2/26-ack'
 import BOOK31COVER from '@/components/Book3/1-cover'
 import BOOK32TITLE_PAGE from '@/components/Book3/2-title_page'
 import BOOK33NOTE from '@/components/Book3/3-note'
 import BOOK34DEDICATION from '@/components/Book3/4-dedication'
 import BOOK35TOC from '@/components/Book3/5-TOC'
 import BOOK36START from '@/components/Book3/6-start'
 import BOOK37CHAP1 from '@/components/Book3/7-chap1'
 import BOOK38CHAP2 from '@/components/Book3/8-chap2'
 import BOOK39CHAP3 from '@/components/Book3/9-chap3'
 import BOOK310CHAP4 from '@/components/Book3/10-chap4'
 import BOOK311CHAP5 from '@/components/Book3/11-chap5'
 import BOOK312CHAP6 from '@/components/Book3/12-chap6'
 import BOOK313CHAP7 from '@/components/Book3/13-chap7'
 import BOOK314CHAP8 from '@/components/Book3/14-chap8'
 import BOOK315CHAP9 from '@/components/Book3/15-chap9'
 import BOOK316CHAP10 from '@/components/Book3/16-chap10'
 import BOOK317CHAP11 from '@/components/Book3/17-chap11'
 import BOOK318CHAP12 from '@/components/Book3/18-chap12'
 import BOOK319CHAP13 from '@/components/Book3/19-chap13'
 import BOOK320CHAP14 from '@/components/Book3/20-chap14'
 import BOOK321CHAP15 from '@/components/Book3/21-chap15'
 import BOOK322CHAP16 from '@/components/Book3/22-chap16'
 import BOOK323CHAP17 from '@/components/Book3/23-chap17'
 import BOOK324CHAP18 from '@/components/Book3/24-chap18'
 import BOOK325CHAP19 from '@/components/Book3/25-chap19'
 import BOOK326CHAP20 from '@/components/Book3/26-chap20'
 import BOOK327CHAP21 from '@/components/Book3/27-chap21'
 import BOOK328CHAP22 from '@/components/Book3/28-chap22'
 import BOOK329CHAP23 from '@/components/Book3/29-chap23'
 import BOOK1PREVIEW1 from '@/components/Book1/preview1'
 import BOOK1PREVIEW from '@/components/Book1/preview'
 import BOOK15STARTPRE from '@/components/Book1/5-start-pre'
 import BOOK16CHAP2PRE from '@/components/Book1/6-chap2-pre'
 import BOOK17CHAP3PRE from '@/components/Book1/7-chap3-pre'
 import LOVE_2 from '@/components/love_2'
 import COPYRIGHT from '@/components/copyright'
 import BOOK1BACKEDBACKAD_1 from '@/components/Book1/Backed/backad_1'
 import BOOK1BACKEDPARTNER_1 from '@/components/Book1/Backed/Partner_1'
 import BOOK1BACKEDPARTNER_2 from '@/components/Book1/Backed/Partner_2'
 import BOOK1BACKEDORIMAD_1 from '@/components/Book1/Backed/ORIM-ad_1'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/bundle_content",
 			"name" : "bundle_content",
 			"component" : BUNDLE_CONTENT
 		},
 		{
 			"path" : "/Book1/1-cover",
 			"name" : "Book1/1-cover",
 			"component" : BOOK11COVER
 		},
 		{
 			"path" : "/Book1/2-title_page",
 			"name" : "Book1/2-title_page",
 			"component" : BOOK12TITLE_PAGE
 		},
 		{
 			"path" : "/Book1/3-dedication",
 			"name" : "Book1/3-dedication",
 			"component" : BOOK13DEDICATION
 		},
 		{
 			"path" : "/Book1/4-TOC",
 			"name" : "Book1/4-TOC",
 			"component" : BOOK14TOC
 		},
 		{
 			"path" : "/Book1/5-start",
 			"name" : "Book1/5-start",
 			"component" : BOOK15START
 		},
 		{
 			"path" : "/Book1/6-chap2",
 			"name" : "Book1/6-chap2",
 			"component" : BOOK16CHAP2
 		},
 		{
 			"path" : "/Book1/7-chap3",
 			"name" : "Book1/7-chap3",
 			"component" : BOOK17CHAP3
 		},
 		{
 			"path" : "/Book1/8-chap4",
 			"name" : "Book1/8-chap4",
 			"component" : BOOK18CHAP4
 		},
 		{
 			"path" : "/Book1/9-chap5",
 			"name" : "Book1/9-chap5",
 			"component" : BOOK19CHAP5
 		},
 		{
 			"path" : "/Book1/10-chap6",
 			"name" : "Book1/10-chap6",
 			"component" : BOOK110CHAP6
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js